<template>
	<div>
		<div class="body-text-1">
			{{ $t('yourFinancialHealth') }}
		</div>
		<div class="heading-2">
			{{ lifeStageData.studentSmileScoreData.message }}
		</div>
		<svgicon
			class="icon"
			:name="
				`financialStatus/${lifeStageData.studentSmileScoreData.message.toLowerCase()}`
			"
			aria-hidden="true"
			:original="true"
		></svgicon>
		<div class="progress-bar-wrapper">
			<div class="progress-bar">
				<div class="bar-section"></div>
				<div class="bar-section"></div>
				<div class="bar-section"></div>
				<div class="bar-section"></div>
			</div>
			<div
				class="filled-bar-wrapper"
				:style="{ width: `${financialHealthPct}%` }"
			>
				<div class="filled-bar"></div>
			</div>
		</div>
	</div>
</template>
<script>
import FinancialHealth from '@/mixins/FinancialHealth';
export default {
	mixins: [FinancialHealth]
};
</script>
<style lang="scss" scoped>
.body-text-1 {
	color: $font-header;
}

.body-text-2 {
	margin: 24px 0 32px 0;
	color: $font-blue;
}

.heading-2 {
	margin: 4px 0 16px 0;
}

.icon {
	width: 100px;
	height: 100px;
	margin-bottom: 16px;
}
.progress-bar-wrapper {
	width: 320px;
	position: relative;
	margin: auto;

	@media (min-width: $breakpoint-mid) {
		width: 450px;
	}

	.progress-bar {
		display: flex;
		width: 320px;
		height: 32px;
		border-radius: 24px;
		background-color: #dfe9f4;

		@media (min-width: $breakpoint-mid) {
			width: 450px;
		}

		.bar-section {
			z-index: 1;
			width: 25%;
			&:not(:last-child) {
				border-right: 1px solid #ffffff;
			}
		}
	}

	.filled-bar-wrapper {
		position: absolute;
		height: 32px;
		border-radius: 24px;
		top: 0;
		left: 0;
		overflow: hidden;

		.filled-bar {
			width: 320px;
			height: 32px;
			border-radius: 24px;
			background: linear-gradient(
				90deg,
				#f83b61 0%,
				#c37b4b 50.6%,
				#109a88 100%
			);

			@media (min-width: $breakpoint-mid) {
				width: 450px;
			}
		}
	}
}
</style>
